const gridProps = () => ({
  vertical: false,
  stroke: 'rgba(0, 0, 0, 0.1)',
  strokeWidth: 1,
});

export default gridProps;
